export { default } from '@/features/purchasesStatistics/api';
